import React, { useEffect, useState } from "react";
import { scrollDetector } from "../../utils/scroll-detector";
import UseWindowSize from "../UseWindowSize";
import { PageSlug } from "../tentang-perusahaan/general";
import fetch from "../../utils/fetch";
import { defBreadcrumb } from "../../data/DataBreadcrumb";
type DetailSlugContentAboutCompanyProps = {
  datas: any;
};

export const DetailSlugContentAboutCompany = ({
  datas
}: DetailSlugContentAboutCompanyProps) => {
  const { asPath, data, itemsForBreadCrumb, breadcrumb, description } = datas;
  const { width } = UseWindowSize();
  const [winSize, setWinSize] = useState(null);
  useEffect(() => {
    setWinSize(width);
    scrollDetector("sticky-share-socmend", "socmed-share-wrapper");
  }, []);

  return (
    <PageSlug
      data={data}
      asPath={asPath}
      breadcrumb={breadcrumb}
      description={description}
      itemsForBreadCrumb={itemsForBreadCrumb}
      winSize={winSize}
    />
  );
};

export const DetailSlugContentAboutCompanyValidator = async (
  slug: string,
  res: any,
  asPath: string,
  pageBreadcrumb: any,
  description: any,
  parentPageName: string,
  parentPagePath: string,
  kenticoPath: string
) => {
  if (slug.includes(".")) {
    if (res) {
      res.writeHead(301, {
        Location: `/halaman-tidak-ditemukan?k=/tentang-perusahaan/${parentPagePath}/${slug}`
      });
      res.end();
    }
    return;
  } else {
    const { status, data } = await fetch("GET", `/kentico/${kenticoPath}`, {
      slug: slug
    });
    if (status === 200) {
      const breadcrumb = [
        ...defBreadcrumb,

        {
          "@type": "ListItem",
          position: "2",
          item: {
            "@id": process.env.baseUrl + "/tentang-perusahaan",
            name: "Tentang Perusahaan"
          }
        },
        {
          "@type": "ListItem",
          position: "3",
          item: {
            "@id": process.env.baseUrl + `/${parentPagePath}`,
            name: parentPageName
          }
        },
        {
          "@type": "ListItem",
          position: "4",
          item: {
            "@id": process.env.baseUrl + asPath,
            name: data.title
          }
        }
      ];

      const itemsForBreadCrumb = [
        ...pageBreadcrumb,
        {
          page: data.title,
          href: `/tentang-perusahaan/${parentPagePath}/${slug}`,
          to: `/tentang-perusahaan/${parentPagePath}/${slug}`
        }
      ];

      return {
        datas: {
          asPath,
          data,
          itemsForBreadCrumb,
          breadcrumb,
          description
        }
      };
    } else {
      if (res) {
        res.writeHead(301, {
          Location: `/halaman-tidak-ditemukan?k=/tentang-perusahaan/${parentPagePath}/${slug}`
        });
        res.end();
      }
      return;
    }
  }
};

export const DetailSlugContentRewardsPromoValidator = async (
  slug: string,
  res: any,
  asPath: string,
  pageBreadcrumb: any,
  query: any,
  parentPageName: string,
  parentPagePath: string,
  kenticoPath: string,
  relatedContentPath: string
) => {
  if (slug.includes(".")) {
    if (res) {
      res.writeHead(301, {
        Location: `/halaman-tidak-ditemukan?k=/${parentPagePath}/${slug}`
      });
      res.end();
    }
    return;
  } else {
    const { status, data } = await fetch("GET", `/kentico/${kenticoPath}`, {
      slug: slug
    });
    if (status === 200) {
      const breadcrumb = [
        ...defBreadcrumb,
        {
          "@type": "ListItem",
          position: "2",
          item: {
            "@id": process.env.baseUrl + `/${parentPagePath}`,
            name: parentPageName
          }
        },
        {
          "@type": "ListItem",
          position: "3",
          item: {
            "@id": process.env.baseUrl + asPath,
            name: data.title
          }
        }
      ];

      const itemsForBreadCrumb = [
        ...pageBreadcrumb,
        {
          page: data.title,
          href: `/${parentPagePath}/${slug}`,
          to: `/${parentPagePath}/${slug}`
        }
      ];

      if (relatedContentPath) {
        const relatedPromos = await fetch(
          "GET",
          `/kentico/${relatedContentPath}`,
          {
            commodity: data.promo_codename,
            limit: 8,
            elements: "promo"
          }
        );

        return {
          datas: {
            asPath,
            data,
            itemsForBreadCrumb,
            breadcrumb,
            relatedPromos,
            slug,
            query
          }
        };
      }

      return {
        datas: {
          asPath,
          data,
          itemsForBreadCrumb,
          breadcrumb,
          slug,
          query
        }
      };
    } else {
      if (res) {
        res.writeHead(301, {
          Location: `/halaman-tidak-ditemukan?k=/${parentPagePath}/${slug}`
        });
        res.end();
      }
      return;
    }
  }
};
